/**
 * A partner's name plus the attributes that tell same-named records apart.
 *
 * Every partner picker in this folder chooses between records that frequently
 * share a name - that is the whole reason merge, regroup and move-access
 * exist. Without the account number / salesperson code beside the name the
 * rows are indistinguishable, and each of those actions is destructive: merge
 * retires records, move-access removes a person from the source, regroup
 * reparents. The network table already showed this; the pickers did not.
 *
 * `attribute_summary` rides on the partnership list payload for exactly this
 * purpose and its view prefetches it, so rendering it costs no extra query.
 */
interface PartnerRowLabelProps {
  name: string | undefined
  attributeSummary: Record<string, unknown> | undefined
}

export function PartnerRowLabel({
  name,
  attributeSummary,
}: PartnerRowLabelProps) {
  const summary = attributeSummary
    ? Object.values(attributeSummary).filter(Boolean).join(' · ')
    : ''
  return (
    <span className="flex min-w-0 items-baseline gap-2">
      <span className="truncate">{name}</span>
      {summary && (
        <span className="truncate text-[11px] text-[var(--ink-3)]">
          {summary}
        </span>
      )}
    </span>
  )
}
